const config = require("./config");

module.exports = {
	plugins: [
		{
			resolve: "gatsby-plugin-mailchimp",
			options: {
				endpoint:
					"https://andrewgriffithsonline.us18.list-manage.com/subscribe/post?u=6c0f7f27a528176b3ca44a358&amp;id=bc49592157"
			}
		},
		{
			resolve: `gatsby-plugin-favicon`,
			options: {
				logo: "./src/images/logo/Light/icon.png",
				injectHTML: true,
				icons: {
					android: true,
					appleIcon: true,
					appleStartup: true,
					coast: false,
					favicons: true,
					firefox: true,
					twitter: true,
					yandex: true,
					windows: true
				}
			}
		},
		"gatsby-plugin-remove-trailing-slashes",
		{
			resolve: "gatsby-plugin-typography",
			options: { pathToConfigModule: "src/utils/typography.js" }
		},
		"gatsby-plugin-catch-links",
		"gatsby-plugin-react-helmet",
		{
			options: { siteUrl: "https://andrewgriffithsonline.com" },
			resolve: "gatsby-plugin-canonical-urls"
		},
		{
			options: { trackingId: "UA-116178207-1" },
			resolve: "gatsby-plugin-google-analytics"
		},
		{
			options: {
				name: "markdown",
				path: `${__dirname}/markdown`
			},
			resolve: "gatsby-source-filesystem"
		},
		{
			options: {
				name: "images",
				path: `${__dirname}/src/images`
			},
			resolve: "gatsby-source-filesystem"
		},
		"gatsby-transformer-sharp",
		"gatsby-plugin-sharp",
		{
			resolve: "gatsby-transformer-remark",
			options: {
				plugins: [
					"gatsby-remark-smartypants",
					"gatsby-remark-prismjs",
					"gatsby-remark-copy-linked-files",
					"gatsby-plugin-sharp",
					{
						// https://www.gatsbyjs.org/packages/gatsby-remark-images/
						resolve: "gatsby-remark-images",
						options: {
							/*
							 * Remove the default behavior of adding a link to each
							 * image.
							 */
							linkImagesToOriginal: false,

							/*
							 * It's important to specify the maxWidth (in pixels) of
							 * the content container as this plugin uses this as the
							 * base for generating different widths of each image.
							 */
							maxWidth: 1600,

							/*
							 * Analyze images' pixel density to make decisions about
							 * target image size. This is what GitHub is doing when
							 * embedding images in tickets. This is a useful setting
							 * for documentation pages with a lot of screenshots.
							 * It can have unintended side effects on high pixel
							 * density artworks.
							 *
							 * Example: A screenshot made on a retina screen with a
							 * resolution of 144 (e.g. Macbook) and a width of 100px,
							 * will be rendered at 50px.
							 *
							 * Defaults to false.
							 */
							sizeByPixelDensity: false
						}
					}
				]
			}
		},
		{
			options: {
				query: `
					{
						site {
							siteMetadata {
								title
								description
								siteUrl
								site_url: siteUrl
							}
						}
					}
				`,
				feeds: [
					{
						serialize: ({ query: { site, allMarkdownRemark } }) => {
							return allMarkdownRemark.edges.map(edge => {
								return Object.assign({}, edge.node.frontmatter, {
									categories: edge.node.frontmatter.tags,
									date: edge.node.frontmatter.date,
									title: edge.node.frontmatter.title,
									description: edge.node.excerpt,
									guid: site.siteMetadata.siteUrl + edge.node.fields.slug,
									url: site.siteMetadata.siteUrl + edge.node.fields.slug,
									// eslint-disable-next-line camelcase
									custom_elements: [{ "content:encoded": edge.node.html }]
								});
							});
						},
						query: `
						{
							allMarkdownRemark(
								limit: 1000,
								sort: { order: DESC, fields: [frontmatter___date] },
								filter: { fields: { slug: { regex: "/^/blog/.+$/" } } }
							) {
								edges {
									node {
										excerpt
										html
										fields { slug }
										frontmatter {
											title
											date
											tags
										}
									}
								}
							}
						}
						`,
						output: "/rss.xml"
					}
				]
			},
			resolve: "gatsby-plugin-feed"
		}
	],
	siteMetadata: config
};



// WEBPACK FOOTER //
// ./gatsby-config.js